"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _TopicConfiguration_1 = require("./_TopicConfiguration");
exports._TopicConfigurationList = {
    type: "list",
    flattened: true,
    member: {
        shape: _TopicConfiguration_1._TopicConfiguration
    }
};
//# sourceMappingURL=_TopicConfigurationList.js.map